export const getTicketIdWithHash = (ticketId: string) => {
  const ticketWithoutHashes = ticketId.replace(/#/g, '');
  return '#' + ticketWithoutHashes;
};
